"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TruncateWithShow = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _styled = require("./styled");

var TruncateWithShow = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(TruncateWithShow, _PureComponent);

  var _super = (0, _createSuper2["default"])(TruncateWithShow);

  function TruncateWithShow() {
    (0, _classCallCheck2["default"])(this, TruncateWithShow);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(TruncateWithShow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          shouldShowAll = _this$props.shouldShowAll,
          children = _this$props.children,
          showMoreString = _this$props.showMoreString,
          onShowAll = _this$props.onShowAll,
          maxCharacters = _this$props.maxCharacters;
      return shouldShowAll ? children : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, "".concat(children.substring(0, maxCharacters).trim(), "... ")), /*#__PURE__*/_react["default"].createElement(_styled.ShowAllLink, {
        onClick: onShowAll
      }, showMoreString));
    }
  }]);
  return TruncateWithShow;
}(_react.PureComponent);

exports.TruncateWithShow = TruncateWithShow;
var _default = TruncateWithShow;
exports["default"] = _default;